import { StandardTaggerLabels } from '@brandfolder/react';

import { loaderLabel } from './loader';

export const getStandardTaggerLabels = (labels: Partial<StandardTaggerLabels> = {}): StandardTaggerLabels => {
  return {
    duplicateOptionLabel: bfTranslate('Duplicate option'),
    emptyLabel: bfTranslate('No options'),
    iconButtonLabel: bfTranslate('Toggle options'),
    label: bfTranslate('Options'),
    listboxLabel: bfTranslate('List of options'),
    loaderLabel,
    removeTagLabel: bfTranslate('Remove'),
    requiredLabel: bfTranslate('Required'),
    ...labels
  };
};
